module.exports = __webpack_public_path__ + "img/U26BD.5a237545.png";